import { useLoginInfo } from 'app/_hooks'
import { FC, useCallback } from 'react'
import * as GA from '~/libs/ga'
import { ScreenPopupModel } from '../hooks/createModel'
import { useScreenPopup } from '../hooks/useScreenPopup'
import AdvertisementModalContent from './AdvertisementModalContent'

const AdvertisementModal: FC = () => {
  const loginInfo = useLoginInfo()
  const {
    onSelectAppearModalNextTime,
    data: screenPopups,
    error,
    handleShowed,
  } = useScreenPopup(loginInfo.status)

  if (error) {
    console.error(error)
    throw error
  }

  // モーダルを閉じる関数
  const onClose = useCallback(
    (isNotShowAgain: boolean, screenPopup: ScreenPopupModel) => {
      GA.sendEvent({
        event: 'click',
        screen: 'popup',
        category: 'popup',
        action: 'close_popup',
        value: JSON.stringify({ id: screenPopup.id, title: screenPopup.title, isNotShowAgain }),
      })
      onSelectAppearModalNextTime(isNotShowAgain, screenPopup.id)
      handleShowed(screenPopup.id)
    },
    [onSelectAppearModalNextTime, handleShowed],
  )

  return (
    <>
      {screenPopups && screenPopups.length > 0 && (
        <AdvertisementModalContent
          screenPopup={screenPopups[0]}
          key={screenPopups[0].id}
          onClose={onClose}
        />
      )}
    </>
  )
}

export default AdvertisementModal
